import { render, staticRenderFns } from "./settingJurisdictionTemplate.vue?vue&type=template&id=038fab10"
import script from "./settingJurisdictionTemplate.vue?vue&type=script&lang=js"
export * from "./settingJurisdictionTemplate.vue?vue&type=script&lang=js"
import style0 from "./settingJurisdictionTemplate.vue?vue&type=style&index=0&id=038fab10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports